import { getLogger } from 'amkit3-modules/utils/log4js'
const logger = getLogger('v/playbacks/factory')
let playbacks = [
  cb => cb(null, require('amkit3-modules/v/playbacks/huya-vod')['default']),
  cb =>
    require.ensure([], require => {
      cb(null, require('amkit3-modules/v/playbacks/html-video')['default'])
    }),
  cb =>
    require.ensure([], require => {
      cb(null, require('amkit3-modules/v/playbacks/html-video-hls2')['default'])
    }),
]

let get = (start, container, options, cb) => {
  logger.info('player factory start:', start)

  let playbackCb = playbacks[start]
  if (!playbackCb) {
    if (typeof MediaSource !== 'function' || typeof String.prototype.repeat !== 'function') {
      cb(
        new Error(
          '很抱歉！当前IE浏览器不支持播放器对m3u8格式视频进行播放剪辑，请更换现代浏览器（chrome,firefox,360,...）进行剪辑。',
        ),
      )
      return
    }
    cb(new Error('no playback available'))
  } else {
    playbackCb((err, PlaybackConstructor) => {
      if (!err) {
        let playback = new PlaybackConstructor(container, options, err => {
          if (err) {
            logger.warn('player factory error:', start, err)
            get(start + 1, container, options, cb)
          } else {
            cb(null, PlaybackConstructor, playback)
          }
        })
      } else {
        logger.warn('player factory error:', start, err)
        get(start + 1, container, options, cb)
      }
    })
  }
}

export default {
  get: (container, options, cb) => get(0, container, options, cb),
}
